module.exports = __webpack_public_path__ + "static/media/opensans-light-webfont.ec1037c4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-light-webfont.woff
// module id = 1018
// module chunks = 0